
<meta-title i18n>
  תוכן לא קיים
</meta-title>

<div container>
  <h2 i18n>
    הכתובת שחפשת לא קיימת במערכת
  </h2>

  <p i18n>
    אם נתקלתם בבעיה במערכת אנא צרו עמנו קשר
    <br>
    כדי שנוכל לעזור לכם.
  </p>

  <p class="ui-support-contact">
    <ui-phone-link color="primary">02-6751152</ui-phone-link>
    <a
      mat-stroked-button
      color="primary"
      href="https://forms-jct.binaa.co.il/it-support-ticket/"
      target="_blank"
      rel="noopener noreferrer">
      <mat-icon>support_agent</mat-icon>&nbsp;
      <span i18n>שלח בקשה לתמיכה</span>
    </a>
  </p>
</div>
